/**
 * Start Your Free Assessment – 5-step form
 */
function initStartYourFreeAssessment() {
	const wrap = document.querySelector( '.start-your-free-assessment' );
	if ( ! wrap || wrap.dataset.syfaInit === '1' ) {
		return;
	}
	wrap.dataset.syfaInit = '1';

	const totalSteps = 5;
	let currentStep = 1;

	const stepCounter = document.getElementById( 'syfa-step-counter' );
	const stepperSteps = wrap.querySelectorAll( '.syfa-step' );
	const stepperLines = wrap.querySelectorAll( '.syfa-step-line' );
	const panels = wrap.querySelectorAll( '.syfa-panel' );
	const privacyBar = wrap.querySelector( '.syfa-privacy' );
	const prevBtn = wrap.querySelector( '.syfa-prev' );
	const nextBtn = wrap.querySelector( '.syfa-next' );
	const nextBtnText = wrap.querySelector( '.syfa-next-text' );
	const form = wrap.querySelector( '.syfa-form' );

	function isValidEmail( email ) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( email );
	}

	function getPanel( step ) {
		return wrap.querySelector( '.syfa-panel[data-step="' + step + '"]' );
	}

	function hasSelection( step ) {
		if ( step <= 4 ) {
			const panel = getPanel( step );
			return !! ( panel && panel.querySelector( 'input[type="radio"]:checked' ) );
		}

		const nameEl = document.getElementById( 'syfa-full-name' );
		const firmEl = document.getElementById( 'syfa-firm-name' );
		const emailEl = document.getElementById( 'syfa-email' );
		const consentEl = document.getElementById( 'syfa-consent' );

		const name = nameEl ? nameEl.value.trim() : '';
		const firm = firmEl ? firmEl.value.trim() : '';
		const email = emailEl ? emailEl.value.trim() : '';
		const consent = consentEl ? consentEl.checked : false;

		return name && firm && isValidEmail( email ) && consent;
	}

	function syncOptionStyles( panel ) {
		panel.querySelectorAll( '.syfa-option' ).forEach( function( option ) {
			const radio = option.querySelector( 'input[type="radio"]' );
			option.classList.toggle( 'is-selected', !!( radio && radio.checked ) );
		} );
	}

	function updateStepper( step ) {
		stepperSteps.forEach( function( el ) {
			const num = parseInt( el.dataset.step, 10 );
			el.classList.remove( 'is-complete', 'is-active', 'is-pending' );
			if ( num < step ) {
				el.classList.add( 'is-complete' );
			} else if ( num === step ) {
				el.classList.add( 'is-active' );
			} else {
				el.classList.add( 'is-pending' );
			}
		} );

		stepperLines.forEach( function( line, index ) {
			line.classList.remove( 'is-complete', 'is-half' );
			if ( index < step - 1 ) {
				line.classList.add( 'is-complete' );
			} else if ( index === step - 1 && step < totalSteps ) {
				line.classList.add( 'is-half' );
			}
		} );
	}

	function updatePanels( step ) {
		panels.forEach( function( panel ) {
			panel.classList.toggle( 'is-active', parseInt( panel.dataset.step, 10 ) === step );
		} );
		if ( privacyBar ) {
			privacyBar.classList.toggle( 'is-hidden', step === totalSteps );
		}
	}

	function updateNav( step ) {
		if ( stepCounter ) {
			stepCounter.textContent = 'Step ' + step + ' of ' + totalSteps;
		}
		if ( prevBtn ) {
			prevBtn.disabled = step === 1;
		}
		if ( nextBtnText ) {
			nextBtnText.textContent = step === totalSteps ? 'Get My Free Assessment' : 'Continue';
		}
		if ( nextBtn ) {
			nextBtn.disabled = ! hasSelection( step );
		}
	}

	function goToStep( step ) {
		currentStep = step;
		updateStepper( step );
		updatePanels( step );
		updateNav( step );
		panels.forEach( function( panel ) {
			syncOptionStyles( panel );
		} );
	}

	wrap.addEventListener( 'click', function( e ) {
		const option = e.target.closest( '.syfa-option' );
		if ( ! option || ! wrap.contains( option ) ) {
			return;
		}

		const panel = option.closest( '.syfa-panel' );
		const radio = option.querySelector( 'input[type="radio"]' );
		if ( ! panel || ! radio ) {
			return;
		}

		panel.querySelectorAll( 'input[type="radio"]' ).forEach( function( input ) {
			input.checked = false;
		} );
		radio.checked = true;

		syncOptionStyles( panel );

		if ( parseInt( panel.dataset.step, 10 ) === currentStep ) {
			updateNav( currentStep );
		}
	} );

	wrap.addEventListener( 'change', function( e ) {
		if ( e.target.type !== 'radio' ) {
			return;
		}

		const panel = e.target.closest( '.syfa-panel' );
		if ( ! panel ) {
			return;
		}

		syncOptionStyles( panel );

		if ( parseInt( panel.dataset.step, 10 ) === currentStep ) {
			updateNav( currentStep );
		}
	} );

	[ 'syfa-full-name', 'syfa-firm-name', 'syfa-email', 'syfa-consent' ].forEach( function( id ) {
		const field = document.getElementById( id );
		if ( ! field ) {
			return;
		}
		field.addEventListener( 'input', function() {
			if ( currentStep === totalSteps ) {
				updateNav( currentStep );
			}
		} );
		field.addEventListener( 'change', function() {
			if ( currentStep === totalSteps ) {
				updateNav( currentStep );
			}
		} );
	} );

	if ( prevBtn ) {
		prevBtn.addEventListener( 'click', function( e ) {
			e.preventDefault();
			if ( currentStep > 1 ) {
				goToStep( currentStep - 1 );
			}
		} );
	}

	if ( nextBtn ) {
		nextBtn.addEventListener( 'click', function( e ) {
			e.preventDefault();

			if ( nextBtn.disabled ) {
				return;
			}

			if ( currentStep < totalSteps ) {
				goToStep( currentStep + 1 );
				return;
			}

			nextBtn.disabled = true;
			if ( nextBtnText ) {
				nextBtnText.textContent = 'Submitting...';
			}

			setTimeout( function() {
				window.alert( 'Thank you! Your free assessment request has been submitted.' );
				if ( form ) {
					form.reset();
				}
				goToStep( 1 );
			}, 800 );
		} );
	}

	if ( form ) {
		form.addEventListener( 'submit', function( e ) {
			e.preventDefault();
		} );
	}

	goToStep( 1 );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initStartYourFreeAssessment );
} else {
	initStartYourFreeAssessment();
}
